__turbopack_context__.v({
  "logo": "Loader-module-scss-module__4qIAAa__logo",
  "pop-in": "Loader-module-scss-module__4qIAAa__pop-in",
});
